import { FC, useMemo } from 'react'

import { ProgressLevelDto } from '../../../model/IntroducingBrokerLoyalty'
import { tierIconByType } from '../../Loyalty/Loyalty'
import { StepItem, Steps } from '../components/Steps/Steps'

export interface TiersProps {
  tiers: ProgressLevelDto
}

export const Tiers: FC<TiersProps> = (props) => {
  const { tiers } = props

  const firstStep = useMemo((): StepItem | undefined => {
    if (tiers?.current) {
      return {
        icon: tierIconByType[tiers.current.id],
        label: tiers.current.label || undefined,
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tiers?.current])

  const isLastTier = tiers.next?.id === tiers.final?.id

  const nextStep: StepItem | undefined =
    tiers.next && !isLastTier
      ? {
          icon: tierIconByType[tiers.next.id],
          label: tiers.next.label || undefined,
        }
      : undefined

  const finalStep: StepItem | undefined = tiers.final
    ? {
        icon: tierIconByType[tiers.final.id],
        label: tiers.final.label || undefined,
      }
    : undefined

  return <Steps firstStep={firstStep} nextStep={nextStep} finalStep={finalStep} />
}
